export const SMART_PAGE_PATHS = {
  // Smart page
  SMART_PAGE_SIGNUP: 'SMART_PAGE_SIGNUP',
  SMART_PAGE_EDITOR: 'SMART_PAGE_EDITOR',
  SMART_PAGE_CUSTOM_DOMAIN: 'SMART_PAGE_CUSTOM_DOMAIN',
};

export const ONBOARDING_PATHS = {
  COLLECT_BUSINESS_INFO: 'COLLECT_BUSINESS_INFO',
  CHINA_DOMESTIC: 'CHINA_DOMESTIC',
  CAMPAIGN_CREATION_METHOD: 'CAMPAIGN_CREATION_METHOD',
  LANGUAGE_COUNTRY: 'LANGUAGE_COUNTRY',
  WEBSITE: 'WEBSITE',
  CAMPAIGN_MODE: 'CAMPAIGN_MODE',

  CAMPAIGN_CREATION_METHOD_SELECTION: 'CAMPAIGN_CREATION_METHOD_SELECTION',
  CAMPAIGN_GOAL_SELECTION: 'CAMPAIGN_GOAL_SELECTION',
  CATALOG_FEED_SELECTION: 'CATALOG_FEED_SELECTION',
  CHANNEL_SELECTION: 'CHANNEL_SELECTION',
  ALL_CAMPAIGN_TYPE_SELECTION: 'ALL_CAMPAIGN_TYPE_SELECTION',

  // Agentic onboarding
  AGENTIC_ANALYZE: 'AGENTIC_ANALYZE',
  AGENTIC_SNAPSHOT_REVIEW: 'AGENTIC_SNAPSHOT_REVIEW',

  // Import
  GOOGLE_IMPORT: 'GOOGLE_IMPORT',
  FACEBOOK_IMPORT: 'FACEBOOK_IMPORT',

  ...SMART_PAGE_PATHS,
};

export const PREVIEW_TO_NON_PREVIEW_MAPPING = {
  PREVIEW_ASSETS: 'AD_ASSETS',
  PREVIEW_ACCOUNT: 'ACCOUNT_DETAILS',
  PREVIEW_PAYMENT: 'PAYMENT',
  PREVIEW_ADD_FUNDS: 'ADD_FUNDS',
};

export const NON_PREVIEW_TO_PREVIEW_MAPPING = {
  AD_ASSETS: 'PREVIEW_ASSETS',
  TARGETING: 'PREVIEW_ASSETS',
  BUDGET: 'PREVIEW_ASSETS',
  ACCOUNT_DETAILS: 'PREVIEW_ACCOUNT',
  PAYMENT: 'PREVIEW_PAYMENT',
  ADD_FUNDS: 'PREVIEW_ADD_FUNDS',
};

export const CAMPAIGN_CREATION_PATHS = {
  // PMAX campaign creation
  AD_ASSETS: 'AD_ASSETS',
  TARGETING: 'TARGETING',
  BUDGET: 'BUDGET',
  PREVIEW_ASSETS: 'PREVIEW_ASSETS',

  // Agentic campaign creation
  CAMPAIGN_DRAFT: 'CAMPAIGN_DRAFT',
  // Sub-steps for Campaign Draft details pages (no sidebar entry — share Step 3 position)
  CAMPAIGN_DRAFT_ASSETS: 'CAMPAIGN_DRAFT_ASSETS',
  CAMPAIGN_DRAFT_BUDGET: 'CAMPAIGN_DRAFT_BUDGET',
  CAMPAIGN_DRAFT_TARGETING: 'CAMPAIGN_DRAFT_TARGETING',

  // Search campaign creation
  SEARCH_CAMPAIGN_SETTINGS: 'SEARCH_CAMPAIGN_SETTINGS',
  SEARCH_CAMPAIGN_KEYWORDS: 'SEARCH_CAMPAIGN_KEYWORDS',
  SEARCH_CAMPAIGN_CREATE_AD: 'SEARCH_CAMPAIGN_CREATE_AD',
  SEARCH_CAMPAIGN_ADD_TEXT: 'SEARCH_CAMPAIGN_ADD_TEXT',
  SEARCH_CAMPAIGN_ADD_MORE_ASSETS: 'SEARCH_CAMPAIGN_ADD_MORE_ASSETS',
  SEARCH_CAMPAIGN_BUDGET_AND_BIDS: 'SEARCH_CAMPAIGN_BUDGET_AND_BIDS',
};

export const PMAX_LITE_WIZARD_STEP_PATHS = {
  ...ONBOARDING_PATHS,
  ...CAMPAIGN_CREATION_PATHS,

  // Account and payment
  ACCOUNT_DETAILS: 'ACCOUNT_DETAILS',
  PAYMENT: 'PAYMENT',
  ADD_FUNDS: 'ADD_FUNDS',

  PREVIEW_ACCOUNT: 'PREVIEW_ACCOUNT',
  PREVIEW_PAYMENT: 'PREVIEW_PAYMENT',
  PREVIEW_ADD_FUNDS: 'PREVIEW_ADD_FUNDS',

  CONVERSION_UPSELL: 'CONVERSION_UPSELL',
  IMPORT_COMPLETE: 'IMPORT_COMPLETE',
};

export const stepToPage = {
  [PMAX_LITE_WIZARD_STEP_PATHS.COLLECT_BUSINESS_INFO]: 'pmaxlite010.collectBusinessInfo',
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_CREATION_METHOD]: 'pmaxlite010.creationMethod',
  [PMAX_LITE_WIZARD_STEP_PATHS.CHINA_DOMESTIC]: 'pmaxlite010.chinaDomestic',
  // Start Import
  [PMAX_LITE_WIZARD_STEP_PATHS.GOOGLE_IMPORT]: 'pmaxlite020.googleImport',
  [PMAX_LITE_WIZARD_STEP_PATHS.FACEBOOK_IMPORT]: 'pmaxlite020.facebookImport',
  // End Import
  [PMAX_LITE_WIZARD_STEP_PATHS.LANGUAGE_COUNTRY]: 'pmaxlite020.languageCountry',
  [PMAX_LITE_WIZARD_STEP_PATHS.WEBSITE]: 'pmaxlite030.website',
  // Start Smart Page
  [PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_SIGNUP]: 'pmaxlite030.smartpage.signup',
  [PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_EDITOR]: 'pmaxlite030.smartpage.editor',
  [PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_CUSTOM_DOMAIN]: 'pmaxlite030.smartpage.customDomain',
  // End Smart Page
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_MODE]: 'pmaxlite040.campaignMode',
  // Campaign Goal Selection
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_CREATION_METHOD_SELECTION]: 'pmaxlite040.creationMethodSelection',
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_GOAL_SELECTION]: 'pmaxlite040.campaignGoalSelection',
  [PMAX_LITE_WIZARD_STEP_PATHS.CATALOG_FEED_SELECTION]: 'pmaxlite040.catalogFeedSelection',
  [PMAX_LITE_WIZARD_STEP_PATHS.CHANNEL_SELECTION]: 'pmaxlite040.channelSelection',
  [PMAX_LITE_WIZARD_STEP_PATHS.ALL_CAMPAIGN_TYPE_SELECTION]: 'pmaxlite040.allCampaignTypeSelection',
  // Agentic onboarding
  [PMAX_LITE_WIZARD_STEP_PATHS.AGENTIC_ANALYZE]: 'pmaxlite030.agentic.analyze',
  [PMAX_LITE_WIZARD_STEP_PATHS.AGENTIC_SNAPSHOT_REVIEW]: 'pmaxlite035.agentic.snapshotReview',
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_DRAFT]: 'pmaxlite060.agentic.campaignDraft',
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_DRAFT_ASSETS]: 'pmaxlite061.agentic.campaignDraftAssets',
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_DRAFT_BUDGET]: 'pmaxlite062.agentic.campaignDraftBudget',
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_DRAFT_TARGETING]: 'pmaxlite063.agentic.campaignDraftTargeting',
  // Start PMax Campaign
  [PMAX_LITE_WIZARD_STEP_PATHS.AD_ASSETS]: 'pmaxlite050.pmax.buildAds',
  [PMAX_LITE_WIZARD_STEP_PATHS.TARGETING]: 'pmaxlite050.pmax.targeting',
  [PMAX_LITE_WIZARD_STEP_PATHS.BUDGET]: 'pmaxlite050.pmax.budget',
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ASSETS]: 'pmaxlite050.pmax.buildAds',
  // End PMax Campaign
  // Start Search Campaign
  [PMAX_LITE_WIZARD_STEP_PATHS.SEARCH_CAMPAIGN_SETTINGS]: 'pmaxlite050.search.campaignSettings',
  [PMAX_LITE_WIZARD_STEP_PATHS.SEARCH_CAMPAIGN_KEYWORDS]: 'pmaxlite050.search.keywords',
  [PMAX_LITE_WIZARD_STEP_PATHS.SEARCH_CAMPAIGN_ADD_TEXT]: 'pmaxlite050.search.createAd',
  [PMAX_LITE_WIZARD_STEP_PATHS.SEARCH_CAMPAIGN_ADD_MORE_ASSETS]: 'pmaxlite050.search.addMoreAssets',
  [PMAX_LITE_WIZARD_STEP_PATHS.SEARCH_CAMPAIGN_BUDGET_AND_BIDS]: 'pmaxlite050.search.budgetAndBids',
  // End Search Campaign
  [PMAX_LITE_WIZARD_STEP_PATHS.ACCOUNT_DETAILS]: 'pmaxlite060.accountDetails',
  [PMAX_LITE_WIZARD_STEP_PATHS.PAYMENT]: 'pmaxlite070.payment',
  [PMAX_LITE_WIZARD_STEP_PATHS.ADD_FUNDS]: 'pmaxlite075.paymentAddFunds',
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ACCOUNT]: 'pmaxlite060.accountDetails',
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_PAYMENT]: 'pmaxlite070.payment',
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ADD_FUNDS]: 'pmaxlite075.paymentAddFunds',
  [PMAX_LITE_WIZARD_STEP_PATHS.CONVERSION_UPSELL]: 'pmaxlite080.conversionUpsell',
  [PMAX_LITE_WIZARD_STEP_PATHS.IMPORT_COMPLETE]: 'pmaxlite085.importComplete',
};

export const CAMPAIGN_TYPE = {
  SEARCH: 'Search',
  SHOPPING: 'Shopping',
  AUDIENCE: 'Audience',
  PMAX: 'Pmax',
  PREMIUM: 'Premium',
  LODGING: 'Lodging',
};

export const CAMPAIGN_CREATION_METHOD = {
  NEW_CAMPAIGN: 'NEW_CAMPAIGN',
  GOOGLE_IMPORT: 'GOOGLE_IMPORT',
  FACEBOOK_IMPORT: 'FACEBOOK_IMPORT',
};

export const GOAL_TYPE = {
  LEADS: 'Leads',
  AWARENESS: 'Awareness',
  CONVERSIONS: 'Conversions',
};

export const CHANNEL_TYPE = {
  SEARCH: 'Search',
  ALL: 'All',
  AUDIENCE: 'Audience',
};

export const PRODUCT_SOURCE_TYPE = {
  CATALOG: 'Catalog',
  FEED: 'Feed',
};
